import { useEffect, useRef } from 'react';

/**
 * 设置页面文档标题的 Hook。
 * - 默认附加应用名后缀（来自 REACT_APP_NAME，默认为“商标管理系统”）。
 * - 可选在卸载时恢复之前的标题。
 */
export function useDocumentTitle(
  title: string,
  options: { restoreOnUnmount?: boolean; appNameSuffix?: boolean } = {}
) {
  const { restoreOnUnmount = false, appNameSuffix = true } = options;
  const prevTitleRef = useRef<string>(document.title);

  useEffect(() => {
    const appName = process.env.REACT_APP_NAME || '商标管理系统';
    const fullTitle = appNameSuffix ? `${title} - ${appName}` : title;
    document.title = fullTitle;

    return () => {
      if (restoreOnUnmount) {
        document.title = prevTitleRef.current;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);
}

export default useDocumentTitle;

